function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_18_search_engine_outline",
  "data-name": "#18_search_engine_outline"
}, /*#__PURE__*/React.createElement("path", {
  d: "M300.05,91.71V197.29a9.8,9.8,0,0,1-9.8,9.8H111.68a9.8,9.8,0,0,1-9.8-9.8V91.71a9.8,9.8,0,0,1,9.8-9.79H290.25A9.79,9.79,0,0,1,300.05,91.71Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.25,208.09H111.68a10.81,10.81,0,0,1-10.8-10.8V91.71a10.8,10.8,0,0,1,10.8-10.79H290.25a10.8,10.8,0,0,1,10.8,10.79V197.29A10.81,10.81,0,0,1,290.25,208.09ZM111.68,82.92a8.8,8.8,0,0,0-8.8,8.79V197.29a8.81,8.81,0,0,0,8.8,8.8H290.25a8.81,8.81,0,0,0,8.8-8.8V91.71a8.8,8.8,0,0,0-8.8-8.79Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.2,147.49v4.4a8.51,8.51,0,0,1-8.51,8.5H125.24a8.51,8.51,0,0,1-8.51-8.5v-4.4a8.5,8.5,0,0,1,8.51-8.5H276.69A8.5,8.5,0,0,1,285.2,147.49Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.69,161.39H125.24a9.52,9.52,0,0,1-9.51-9.5v-4.4a9.52,9.52,0,0,1,9.51-9.5H276.69a9.52,9.52,0,0,1,9.51,9.5v4.4A9.52,9.52,0,0,1,276.69,161.39ZM125.24,140a7.52,7.52,0,0,0-7.51,7.5v4.4a7.51,7.51,0,0,0,7.51,7.5H276.69a7.51,7.51,0,0,0,7.51-7.5v-4.4a7.52,7.52,0,0,0-7.51-7.5Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M300.05,91.71V101H101.88v-9.3a9.8,9.8,0,0,1,9.8-9.79H290.25A9.79,9.79,0,0,1,300.05,91.71Z",
  fill: "#68e1fd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M300.05,102H101.88a1,1,0,0,1-1-1v-9.3a10.8,10.8,0,0,1,10.8-10.79H290.25a10.8,10.8,0,0,1,10.8,10.79V101A1,1,0,0,1,300.05,102Zm-197.17-2H299.05v-8.3a8.8,8.8,0,0,0-8.8-8.79H111.68a8.8,8.8,0,0,0-8.8,8.79Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113.99,
  cy: 90.76,
  r: 2.41,
  fill: "#f56132"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122.73,
  cy: 90.76,
  r: 2.41,
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131.48,
  cy: 90.76,
  r: 2.41,
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.2,147.49v4.4a8.51,8.51,0,0,1-8.51,8.5h-16.5V139h16.5A8.5,8.5,0,0,1,285.2,147.49Z",
  fill: "#70cc40"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.69,161.39h-16.5a1,1,0,0,1-1-1V139a1,1,0,0,1,1-1h16.5a9.52,9.52,0,0,1,9.51,9.5v4.4A9.52,9.52,0,0,1,276.69,161.39Zm-15.5-2h15.5a7.51,7.51,0,0,0,7.51-7.5v-4.4a7.52,7.52,0,0,0-7.51-7.5h-15.5Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M270,154.3a6.65,6.65,0,1,1,4.7-11.35h0A6.65,6.65,0,0,1,270,154.3Zm0-11.3a4.65,4.65,0,1,0,3.29,1.36A4.63,4.63,0,0,0,270,143Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M278.44,157.09a1,1,0,0,1-.7-.29l-4.45-4.44a1,1,0,0,1,1.42-1.42l4.44,4.44a1,1,0,0,1,0,1.42A1,1,0,0,1,278.44,157.09Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("rect", {
  x: 161.18,
  y: 186.73,
  width: 11.77,
  height: 21.5,
  transform: "translate(144.54 -60.21) rotate(35.24)",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.67,210.66a.93.93,0,0,1-.57-.19l-9.62-6.79a1,1,0,0,1-.41-.64,1.05,1.05,0,0,1,.17-.75l12.41-17.56a1,1,0,0,1,.64-.41,1.05,1.05,0,0,1,.75.17l9.61,6.79a1,1,0,0,1,.41.65.93.93,0,0,1-.17.74l-12.4,17.56A1,1,0,0,1,165.67,210.66Zm-8.22-8,8,5.63,11.25-15.92-8-5.64Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("rect", {
  x: 167.74,
  y: 172.99,
  width: 18.07,
  height: 21.5,
  transform: "translate(138.39 -68.32) rotate(35.24)",
  fill: "#68e1fd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178,198.73a1,1,0,0,1-.58-.18l-14.75-10.42a1,1,0,0,1-.24-1.4l12.4-17.56a1.05,1.05,0,0,1,.65-.41,1,1,0,0,1,.74.17l14.76,10.43a1,1,0,0,1,.24,1.39l-12.4,17.56a1,1,0,0,1-.65.41Zm-13.36-11.66,13.12,9.27L189,180.41l-13.12-9.27Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("rect", {
  x: 139.37,
  y: 199.29,
  width: 18.07,
  height: 49.25,
  rx: 3.85,
  transform: "translate(156.37 -44.59) rotate(35.24)",
  fill: "#68e1fd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.64,248.72a4.81,4.81,0,0,1-2.79-.89h0l-8.47-6a4.85,4.85,0,0,1-1.16-6.76l24-33.94A4.85,4.85,0,0,1,159,200l8.47,6a4.86,4.86,0,0,1,1.16,6.76l-24,33.94A4.85,4.85,0,0,1,140.64,248.72ZM139,246.2a2.85,2.85,0,0,0,4-.68l24-33.94a2.85,2.85,0,0,0-.69-4l-8.47-6a2.85,2.85,0,0,0-4,.69l-24,33.94a2.8,2.8,0,0,0-.48,2.12,2.85,2.85,0,0,0,1.16,1.85l8.47,6Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224.13,116.69a42.46,42.46,0,1,0,10.19,59.18A42.46,42.46,0,0,0,224.13,116.69Zm-40.85,57.84a28.35,28.35,0,1,1,39.51-6.8A28.35,28.35,0,0,1,183.28,174.53Z",
  fill: "#68e1fd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M199.54,194.85a43.47,43.47,0,1,1,25.17-79h0A43.47,43.47,0,0,1,207,194.21,43.9,43.9,0,0,1,199.54,194.85Zm.15-84.92a41.42,41.42,0,1,0,23.87,7.58A41.44,41.44,0,0,0,199.69,109.93Zm-.1,70.78a29.34,29.34,0,1,1,24-12.4A29.24,29.24,0,0,1,199.59,180.71Zm.08-56.67a27.33,27.33,0,1,0,15.74,5A27.31,27.31,0,0,0,199.67,124Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199.63,
  cy: 151.38,
  r: 28.35,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M199.59,180.71a29.32,29.32,0,1,1,24-12.4A29.24,29.24,0,0,1,199.59,180.71Zm.08-56.67a27.33,27.33,0,1,0,15.74,5A27.31,27.31,0,0,0,199.67,124Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.8,148.56a1.37,1.37,0,0,0-.6-.41,2.1,2.1,0,0,0-.71-.13,1.48,1.48,0,0,0-.41,0,1.64,1.64,0,0,0-.39.14.94.94,0,0,0-.3.26.71.71,0,0,0,.16,1,2.68,2.68,0,0,0,.7.34l.91.28a3.68,3.68,0,0,1,.91.39,2.27,2.27,0,0,1,.7.68,2.06,2.06,0,0,1,.28,1.15,2.61,2.61,0,0,1-.26,1.19,2.49,2.49,0,0,1-.69.85,3,3,0,0,1-1,.5,4.84,4.84,0,0,1-1.21.16,4.48,4.48,0,0,1-1.49-.24,3.9,3.9,0,0,1-1.27-.79l1.28-1.42a1.91,1.91,0,0,0,.71.58,2,2,0,0,0,.87.2,2.3,2.3,0,0,0,.45-.05,1.59,1.59,0,0,0,.4-.16.92.92,0,0,0,.29-.26.71.71,0,0,0,.11-.39.68.68,0,0,0-.28-.58,2.78,2.78,0,0,0-.71-.37l-.93-.3a4.28,4.28,0,0,1-.93-.4,2.39,2.39,0,0,1-.71-.67,1.93,1.93,0,0,1-.28-1.1,2.37,2.37,0,0,1,.26-1.16,2.45,2.45,0,0,1,.69-.84,3,3,0,0,1,1-.5,4.19,4.19,0,0,1,1.17-.17,4.69,4.69,0,0,1,1.35.2,3.1,3.1,0,0,1,1.17.66Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.5,153.79a2.83,2.83,0,0,1-1.05.82,3.25,3.25,0,0,1-1.33.29,3.56,3.56,0,0,1-1.22-.21,2.92,2.92,0,0,1-1-.6,2.61,2.61,0,0,1-.67-.93,3.2,3.2,0,0,1,0-2.43,2.7,2.7,0,0,1,.67-.93,2.92,2.92,0,0,1,1-.6,3.56,3.56,0,0,1,1.22-.21,2.77,2.77,0,0,1,1.1.21,2.19,2.19,0,0,1,.83.6,2.66,2.66,0,0,1,.53.93,3.86,3.86,0,0,1,.19,1.22v.54h-4a1.37,1.37,0,0,0,.46.79,1.24,1.24,0,0,0,.85.3,1.3,1.3,0,0,0,.73-.19,2,2,0,0,0,.51-.49ZM189,151.31a1,1,0,0,0-.29-.75,1,1,0,0,0-.78-.32,1.19,1.19,0,0,0-.51.1,1.37,1.37,0,0,0-.37.23,1,1,0,0,0-.25.34,1.38,1.38,0,0,0-.1.4Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M195.35,154.05h0a1.57,1.57,0,0,1-.77.65,2.66,2.66,0,0,1-1.77.09,1.82,1.82,0,0,1-.65-.33,1.7,1.7,0,0,1-.44-.55,1.9,1.9,0,0,1,0-1.57,1.64,1.64,0,0,1,.49-.56,2.53,2.53,0,0,1,.7-.34,5.17,5.17,0,0,1,.82-.18,7.93,7.93,0,0,1,.84-.07h.78a.89.89,0,0,0-.33-.73,1.15,1.15,0,0,0-.78-.28,1.69,1.69,0,0,0-.78.18,2,2,0,0,0-.63.5l-.93-.95a3.07,3.07,0,0,1,1.14-.68,4.06,4.06,0,0,1,1.34-.23,3.71,3.71,0,0,1,1.26.19,1.83,1.83,0,0,1,.78.56,2.25,2.25,0,0,1,.42.91,6.6,6.6,0,0,1,.11,1.25v2.86h-1.6Zm-.43-1.76-.49,0a2.28,2.28,0,0,0-.57.1,1.19,1.19,0,0,0-.46.24.55.55,0,0,0-.19.45.5.5,0,0,0,.27.47,1.08,1.08,0,0,0,.55.15,1.57,1.57,0,0,0,.49-.07,1.54,1.54,0,0,0,.43-.2.91.91,0,0,0,.4-.79v-.37Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198,149.13h1.74v.9h0a2.35,2.35,0,0,1,.66-.78,1.72,1.72,0,0,1,1-.26h.3l.28.05v1.59a2.37,2.37,0,0,0-.36-.09,2.34,2.34,0,0,0-.38,0,1.93,1.93,0,0,0-.79.14,1,1,0,0,0-.44.39,1.34,1.34,0,0,0-.21.6,5.92,5.92,0,0,0,0,.76v2.35H198Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.36,151a1.05,1.05,0,0,0-.86-.43,1.36,1.36,0,0,0-1,.39,1.67,1.67,0,0,0,0,2.07,1.36,1.36,0,0,0,1,.39.91.91,0,0,0,.5-.13,1.31,1.31,0,0,0,.36-.3l1.14,1.21a2.29,2.29,0,0,1-.95.58,3.7,3.7,0,0,1-1.05.17,3.51,3.51,0,0,1-1.22-.21,3,3,0,0,1-1-.6,2.71,2.71,0,0,1-.66-.93,3,3,0,0,1,.66-3.36,3,3,0,0,1,1-.6,3.51,3.51,0,0,1,1.22-.21,3.7,3.7,0,0,1,1.05.17,2.29,2.29,0,0,1,.95.58Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.87,146v3.9h0a1,1,0,0,1,.2-.33,1.56,1.56,0,0,1,.33-.29,2.29,2.29,0,0,1,.47-.21,2.07,2.07,0,0,1,.57-.08,2.34,2.34,0,0,1,1.07.21,1.49,1.49,0,0,1,.63.56,2.22,2.22,0,0,1,.31.84,7,7,0,0,1,.08,1.06v3.1h-1.74V152a4.26,4.26,0,0,0,0-.5,1.52,1.52,0,0,0-.1-.48.82.82,0,0,0-.27-.36.84.84,0,0,0-.51-.14,1.12,1.12,0,0,0-.55.12.82.82,0,0,0-.31.33,1.09,1.09,0,0,0-.15.45,4.63,4.63,0,0,0,0,.54v2.8h-1.74V146Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.81,153.76a1.15,1.15,0,0,1,.08-.41,1,1,0,0,1,.23-.34,1,1,0,0,1,.34-.23,1.16,1.16,0,0,1,.42-.08,1.15,1.15,0,0,1,.41.08.93.93,0,0,1,.35.23,1,1,0,0,1,.22.34,1,1,0,0,1,.08.41,1,1,0,0,1-.08.42,1,1,0,0,1-.22.34,1.07,1.07,0,0,1-.35.23,1.15,1.15,0,0,1-.41.08,1.16,1.16,0,0,1-.42-.08,1.13,1.13,0,0,1-.34-.23,1,1,0,0,1-.23-.34A1.16,1.16,0,0,1,214.81,153.76Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.24,153.76a1.15,1.15,0,0,1,.08-.41,1,1,0,0,1,.23-.34.89.89,0,0,1,.34-.23,1.16,1.16,0,0,1,.42-.08,1.15,1.15,0,0,1,.41.08,1.08,1.08,0,0,1,.57.57,1.15,1.15,0,0,1,.08.41,1.16,1.16,0,0,1-.08.42.89.89,0,0,1-.23.34,1,1,0,0,1-.34.23,1.15,1.15,0,0,1-.41.08,1.16,1.16,0,0,1-.42-.08,1.08,1.08,0,0,1-.57-.57A1.16,1.16,0,0,1,218.24,153.76Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M221.67,153.76a1.15,1.15,0,0,1,.08-.41,1.08,1.08,0,0,1,.57-.57,1.15,1.15,0,0,1,.41-.08,1.16,1.16,0,0,1,.42.08,1.08,1.08,0,0,1,.57.57,1.15,1.15,0,0,1,.08.41,1.16,1.16,0,0,1-.08.42.89.89,0,0,1-.23.34,1,1,0,0,1-.34.23,1.16,1.16,0,0,1-.42.08,1.15,1.15,0,0,1-.41-.08,1,1,0,0,1-.34-.23.89.89,0,0,1-.23-.34A1.16,1.16,0,0,1,221.67,153.76Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("rect", {
  x: 84.43,
  y: 175.96,
  width: 48.23,
  height: 39.6,
  rx: 4.94,
  fill: "#f56132"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.72,216.56H89.36a5.94,5.94,0,0,1-5.93-5.94V180.89A5.94,5.94,0,0,1,89.36,175h38.36a6,6,0,0,1,5.94,5.93v29.73A6,6,0,0,1,127.72,216.56ZM89.36,177a3.93,3.93,0,0,0-3.93,3.93v29.73a3.93,3.93,0,0,0,3.93,3.94h38.36a3.94,3.94,0,0,0,3.94-3.94V180.89a3.94,3.94,0,0,0-3.94-3.93Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "100.58 207.06 100.58 184.46 120.32 195.76 100.58 207.06",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.58,208.06a1,1,0,0,1-.5-.13,1,1,0,0,1-.5-.87v-22.6a1,1,0,0,1,.5-.87,1,1,0,0,1,1,0l19.74,11.3a1,1,0,0,1,0,1.74l-19.74,11.3A1,1,0,0,1,100.58,208.06Zm1-21.88v19.16l16.73-9.58Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("rect", {
  x: 263.16,
  y: 88.39,
  width: 52.41,
  height: 38.53,
  rx: 3.46,
  fill: "#ffbc0e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.11,127.92H266.62a4.46,4.46,0,0,1-4.46-4.46V91.85a4.46,4.46,0,0,1,4.46-4.46h45.49a4.46,4.46,0,0,1,4.46,4.46v31.61A4.46,4.46,0,0,1,312.11,127.92ZM266.62,89.39a2.46,2.46,0,0,0-2.46,2.46v31.61a2.47,2.47,0,0,0,2.46,2.46h45.49a2.46,2.46,0,0,0,2.46-2.46V91.85a2.46,2.46,0,0,0-2.46-2.46Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M263.16,122.82a1,1,0,0,1-.66-.25,1,1,0,0,1-.08-1.42L279,102.52a1.07,1.07,0,0,1,.69-.33,1,1,0,0,1,.73.26l17.15,15.39a1,1,0,0,1-1.33,1.49L279.87,104.6l-16,17.89A1,1,0,0,1,263.16,122.82Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.54,116.53a1,1,0,0,1-.74-.32,1,1,0,0,1,.06-1.42l9.88-9.1a1,1,0,0,1,1.23-.1l12.16,8.14A1,1,0,1,1,315,115.4l-11.51-7.7-9.29,8.56A1,1,0,0,1,293.54,116.53Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 293.54,
  cy: 99.22,
  r: 3.97,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.54,104.19a5,5,0,1,1,5-5A5,5,0,0,1,293.54,104.19Zm0-7.94a3,3,0,1,0,3,3A3,3,0,0,0,293.54,96.25Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "312.51 214.82 278.92 214.82 278.92 183.88 285.97 177.04 312.51 177.04 312.51 214.82",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.51,215.82H278.92a1,1,0,0,1-1-1V183.88a1,1,0,0,1,.31-.72l7-6.83a1,1,0,0,1,.7-.29h26.54a1,1,0,0,1,1,1v37.78A1,1,0,0,1,312.51,215.82Zm-32.59-2h31.59V178H286.37l-6.45,6.26Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "278.92 183.88 285.9 183.88 285.9 177.04 278.92 183.88",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.9,184.88h-7a1,1,0,0,1-.7-1.72l7-6.83a1,1,0,0,1,1.08-.21,1,1,0,0,1,.62.92v6.84A1,1,0,0,1,285.9,184.88Zm-4.53-2h3.53v-3.46Z",
  fill: "#093f68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.27,190.59h-21.1a1,1,0,0,1,0-2h21.1a1,1,0,0,1,0,2Z",
  fill: "#dfeaef"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.27,198.29h-21.1a1,1,0,0,1,0-2h21.1a1,1,0,0,1,0,2Z",
  fill: "#dfeaef"
}), /*#__PURE__*/React.createElement("path", {
  d: "M301.19,206h-16a1,1,0,0,1,0-2h16a1,1,0,0,1,0,2Z",
  fill: "#dfeaef"
}));

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.92f36f05.svg";
export { ForwardRef as ReactComponent };